import { useEffect } from 'react'

import Api from 'services/api'

import { useStoreContext } from 'hooks/StoreContext'

const useConsolidatedEvents = () => {
  const { consolidatedEvents, setConsolidatedEvents, areConsolidatedEventsLoaded, setAreConsolidatedEventsLoaded } = useStoreContext()

  useEffect(() => {
    if (areConsolidatedEventsLoaded) {
      return
    }

    setConsolidatedEvents(null)
    setAreConsolidatedEventsLoaded(false)

    Api.ConsolidatedEvents.list()
      .then(res => {
        setConsolidatedEvents(res)
      })
      .catch(() => {
        setConsolidatedEvents(null)
      })
      .finally(() => {
        setAreConsolidatedEventsLoaded(true)
      })
  }, [areConsolidatedEventsLoaded, setConsolidatedEvents, setAreConsolidatedEventsLoaded])

  return { consolidatedEvents, areConsolidatedEventsLoaded }
}

export default useConsolidatedEvents
